import React from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TextAreaInputField, TextInputField } from '../../../components/FormCom/FormField';
import NumberOnlyInputField from '../../../components/FormCom/NumberOnlyInputField';
import useSetContactUs from '../../../hooks/contactUs/useSetContactUs';
import {
  ContactUsDataType,
  contactUsInitialValues,
  ContactUsSchema,
} from '../../../models/contacts/contacts.model';

const RightPart = () => {
  const { contactUs, resetInputFields } = useSetContactUs();

  const onSubmit = (values: ContactUsDataType, actions: any) => {
    console.log('Lemoa!!', values);
    contactUs(values);
    if (resetInputFields) {
      actions.resetForm(contactUsInitialValues);
    }
  };

  return (
    <Container>
      {/* <Header>Send us a message</Header> */}
      <FormComponent
        initialValues={contactUsInitialValues}
        schema={ContactUsSchema}
        onSubmit={onSubmit}
      >
        <FieldRow>
          <TextInputField label='First Name' name='firstName' type='text' />
          <TextInputField label='Last Name' name='lastName' type='text' />
        </FieldRow>
        <FieldRow>
          <TextInputField label='Email Address' name='email' type='text' />
          <NumberOnlyInputField label='Phone Number' name='phoneNumber' type='text' />
        </FieldRow>

        <TextInputField label='Subject' name='subject' type='text' />

        <TextAreaInputField
          label='Description'
          name='description'
          type='text'
        />
        <FormSubmitButton className='fit-content flex-end'>
          Send
        </FormSubmitButton>
      </FormComponent>
    </Container>
  );
};

export default RightPart;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

// const Header = styled.div`
//   font-size: 21px;
//   line-height: 21px;
//   font-weight: 600;
// `;

const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
